import Finance from "@/views/static/finance";
import { LINKS } from "./links";
import PageTypeThree from "@/views/static/pre-format-page/page-type-three";
import IndustryFourTable from "@/views/static/tables/industry-four-table";
import IndustryFiveTable from "@/views/static/tables/industry-five-table";
import NuovaSabatiniTable from "@/views/static/tables/nuova-sabatini-table";
import ZesTable from "@/views/static/tables/zes-table";
import SimsetTable from "@/views/static/tables/simset-table";
import PageTypeOne from "@/views/static/pre-format-page/page-type-one";
import SoftwareMes from "@/views/static/software-mes";
import About from "@/views/static/about";
import Contacts from "@/views/contacts";
import Home from "@/views/static/home";
import PageTypeTwo from "@/views/static/pre-format-page/page-type-two";
import LocalAnnouncements from "@/views/static/local-announcements";
import Partners from "@/views/static/partners";
import PartnersDetail from "@/views/static/partners/detail";
import RequestOk from "@/views/static/request-ok";
import { TEXTS } from "./site-texts";

export const STATIC_PAGES = [
  {
    path: LINKS.HOME,
    Page: <Home content={TEXTS.home} />,
  },
  {
    path: LINKS.FINANCE,
    Page: <Finance content={TEXTS.finance} />,
  },
  {
    path: LINKS.LOCAL_ANNOUNCEMENTS,
    Page: <LocalAnnouncements content={TEXTS.localAnnouncements} />,
  },
  {
    path: LINKS.CLICK_DAY,
    Page: <PageTypeTwo content={TEXTS.clickDay} />,
  },
  {
    path: LINKS.SOFTWARE_MES_4,
    Page: <SoftwareMes content={TEXTS.softwareMES} />,
  },
  {
    path: LINKS.ABOUT,
    Page: <About content={TEXTS.about} />,
  },
  {
    path: LINKS.CONTACTS,
    Page: <Contacts content={TEXTS.contacts} />,
  },
  {
    path: LINKS.INDUSTRY_4,
    Page: (
      <PageTypeThree
        content={TEXTS.industryFour}
        Table={<IndustryFourTable />}
      />
    ),
  },
  {
    path: LINKS.INDUSTRY_5,
    Page: (
      <PageTypeThree
        content={TEXTS.industryFive}
        Table={<IndustryFiveTable />}
      />
    ),
  },
  {
    path: LINKS.NUOVA_SABATINI,
    Page: (
      <PageTypeThree
        content={TEXTS.nuovaSabatini}
        Table={<NuovaSabatiniTable />}
      />
    ),
  },
  {
    path: LINKS.ZES,
    Page: <PageTypeThree content={TEXTS.zes} Table={<ZesTable />} />,
  },
  {
    path: LINKS.SIMEST,
    Page: <PageTypeThree content={TEXTS.simest} Table={<SimsetTable />} />,
  },
  {
    path: LINKS.GESTIONE_CONTRIBUTI,
    Page: <PageTypeOne content={TEXTS.contributionsManagement} />,
  },
  {
    path: LINKS.PERIZIE_4,
    Page: <PageTypeOne content={TEXTS.industryAppraisalsFour} />,
  },
  {
    path: LINKS.CERTIFICAZIONE_5,
    Page: <PageTypeOne content={TEXTS.industryCertificationFive} />,
  },
  {
    path: LINKS.PERIZIE_INAIL,
    Page: <PageTypeOne content={TEXTS.noticeAppraisals} />,
  },
  {
    path: LINKS.PARTNERS,
    Page: <Partners content={TEXTS.partners} />,
  },
  {
    path: LINKS.PARTNER_DETAIL,
    Page: <PartnersDetail />,
  },
  {
    path: LINKS.REQUEST_CONFIRMED,
    Page: <RequestOk />,
  },
];
